// extracted by css-extract-rspack-plugin
export default {"cls1":"AutoCompleteResultRow-cls1_BjV","cls2":"AutoCompleteResultRow-cls2_Y_D AutoCompleteResultRow-cls1_BjV","highlighted":"AutoCompleteResultRow-highlighted_q4_"};